import React from 'react';
import Button from '@mui/material/Button';

let CrearUsuario = (props) => {
    return (
        <Button
            style={{ marginLeft: '5px' }}
            disabled={props.disabled}
            onClick={() => props.onClick()}
            variant="contained"
            color={props.color ? props.color : "primary"}
            >
            {props.tittle ?? 'Crear'}
        </Button>
    );
}

export default CrearUsuario;

  

